export default __webpack_public_path__ + "static/small-image-bimp-1-74da970ad2184b3ed6952f26c75e5b43.png";